


















































import { Component, Vue } from 'vue-property-decorator';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import { i18nMixin } from '../../mixins';
import { NameValue, NameValues } from '@/modules/neodash/model/types/interfaces/NameValue';
import { FilterOldService } from '@/modules/neodash/services/filterOldService';
import { Filters } from '@/modules/neodash/pages/registrationByBrandAndSegment/Filters';
import { GET_PERIOD } from '@/modules/neodash/store/modules/reports/types';
import { Getter } from 'vuex-class';
import { ReportEnum } from '@/modules/neodash/model/types/enums/reportEnum';
import { Period } from '@/modules/neodash/model/types/interfaces/Period';
import MonthYearForm from '@/modules/neodash/components/filter-form/month-year-form/month-year-form.vue';
import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import { BrandSegmentReportContextEnum } from '@/enums/brand-segment-report-context.enum';
import { IKeyValues } from '@/interfaces/key-value-interface';
import { FormFilterFields } from '../../model/types/interfaces/FormFilterFields';
import _ from 'lodash';
import { TypeLocality } from '@/modules/neodash/model/types/interfaces/TypeLocality';
import { SaleTypeEnum } from '@/enums/sale-type.enum';
import { listAllTypesLocalityLevel } from '@/modules/neodash/model/constants/typeLocalityLevel';
import { i18nService } from '@/services';
import { Report } from '@/modules/neodash/model/types/interfaces/Report';
import { LIST_REPORTS } from '@/modules/neodash/store/modules/reports/types';

const TotalSalesId = 3;

@Component({
  name: 'RegistrationBrandSegmentFilter',
  components: {
    FormPeriod,
    FilterMultiSelect,
    FilterContainer,
    FilterDropDown,
    MonthYearForm
  }
})
export default class RegistrationBrandSegmentFilter extends Vue {
  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  @Getter(LIST_REPORTS)
  public listReports: Report[];

  public readonly translate = i18nMixin.methods.i18n;
  public readonly SaleTypeEnum = SaleTypeEnum;
  public filtersModel: Filters = {
    chosenLicensePlate: null,
    chosenLocalityLevel: null,
    chosenLocalityType: null,
    localities: [],
    companySizes: [],
    chosenPeriod: null,
    dsRegistrationReportContext: null,
    calculatedLocalityLevelAndType: undefined
  };

  public limitValues: Period;
  public isLoading: boolean = true;
  public readonly keyLabelLicensePlate: string = 'Common.LicensePlateType';
  public readonly keyLabelLocalityLevel: string = 'Common.LocalityLevel';
  public readonly keyLabelLocalityType: string = 'Common.LocalityType';
  public readonly keyLabelLocalities: string = 'Common.Localities';
  public readonly keyLabelDSReport: string = 'Common.ReportFormat';
  public readonly keyLabelCompanySize: string = 'Common.CompanySize';

  public allLicensePlateTypes: NameValues = [];
  public allLevelLocalities: NameValues = listAllTypesLocalityLevel();
  public clientLocalities: NameValues = [];
  public allTypeLocalitiesDictionary: TypeLocality[];
  public allLocalities: NameValues = [];
  public allCompanySize: NameValues = [];
  public DSRegistrationReportContexts: NameValues = [
    {
      value: BrandSegmentReportContextEnum.byBrand,
      name: i18nService.i18n('Filters.ByBrand')
    } as NameValue,
    {
      value: BrandSegmentReportContextEnum.inSegment,
      name: i18nService.i18n('Filters.BySegment')
    } as NameValue
  ];

  public created(): void {
    const { getTypesLicensePlate, getTypesCompanySize } = FilterOldService;

    Promise.all([getTypesLicensePlate(), getTypesCompanySize()])
      .then(([licencePlates, companySizes]) => {
        const report = this.listReports.find(r => r.id === ReportEnum.RegistrationByBrandAndSegment);
        if (report && report.clientTotalSales) {
          this.allLicensePlateTypes = licencePlates.filter(lp => lp.value === TotalSalesId);
        } else {
          this.allLicensePlateTypes = licencePlates;
        }
        this.allCompanySize = companySizes;
      });
  }

  public handleLocalityType(localityLevel: NameValue) {
    FilterOldService.getTypeLocality(localityLevel).then(x => {
      this.clientLocalities = x.map((x: TypeLocality) => ({ value: x.value, name: x.name } as NameValue));
      this.allTypeLocalitiesDictionary = x;
    });
  }

  public handleLocalities(localityType: TypeLocality) {
    FilterOldService.getLocalities(localityType).then(x => {
      this.allLocalities = x;
    });
  }

  public showReport() {
    if (!this.isDirectSales) {
      this.filtersModel.companySizes = [];
    }

    this.$emit('input', this.value);
    setTimeout(() => this.$emit('showReport'), 200);
  }

  public get isDirectSales() {
    return this.filtersModel.chosenLicensePlate && this.filtersModel.chosenLicensePlate.value === SaleTypeEnum.DirectSales
  }

  private get value(): FormFilterFields<Filters> {
    if (!this.formValid)
      return {
        value: {} as Filters,
        labels: []
      } as FormFilterFields<Filters>;

    this.filtersModel.calculatedLocalityLevelAndType = _.find(
      this.allTypeLocalitiesDictionary,
      x => !!this.filtersModel.chosenLocalityType && this.filtersModel.chosenLocalityType.value === x.id
    );

    return {
      value: this.filtersModel,
      labels: this.labels
    };
  }

  public get labels(): IKeyValues {
    const {
      translate,
      keyLabelLocalityType,
      keyLabelLocalities,
      keyLabelLocalityLevel,
      keyLabelLicensePlate,
      keyLabelDSReport,
      keyLabelCompanySize
    } = this;
    const {
      dsRegistrationReportContext,
      chosenLocalityLevel,
      chosenLicensePlate,
      chosenLocalityType,
      localities,
      chosenPeriod,
      companySizes
    } = this.filtersModel;
    if (
      !keyLabelLocalityType ||
      !keyLabelLocalities ||
      !keyLabelLocalityLevel ||
      !keyLabelLicensePlate ||
      !keyLabelDSReport
    ) {
      return [];
    }

    const [
      labelLocalityType,
      labelLocalities,
      labelLocalityLevel,
      labelCompanySize,
      labelLicensePlate,
      labelDSReport,
      labelPeriodInit,
      labelPeriodEnd,
    ]: Array<string> = [
      keyLabelLocalityType,
      keyLabelLocalities,
      keyLabelLocalityLevel,
      keyLabelCompanySize,
      keyLabelLicensePlate,
      keyLabelDSReport,
      'Common.Initial',
      'Common.End'
    ].map(x => translate(x));

    const periodsLabel = !!chosenPeriod ? chosenPeriod.label.split(' - ') : ['', ''];

    return [
      { text: labelLocalityType, value: !!chosenLocalityType ? chosenLocalityType.name : '' },
      { text: labelPeriodInit, value: periodsLabel[0] },
      { text: labelPeriodEnd, value: periodsLabel[1] },
      { text: labelLocalities, value: localities.map(x => x.name).join(' - ') },
      { text: labelCompanySize, value: !!companySizes ? companySizes.map(x => x.name).join(' - ') : '' },
      { text: labelLocalityLevel, value: !!chosenLocalityLevel ? chosenLocalityLevel.name : '' },
      { text: labelLicensePlate, value: !!chosenLicensePlate ? chosenLicensePlate.name : '' },
      { text: labelDSReport, value: !!dsRegistrationReportContext ? dsRegistrationReportContext.name : '' }
    ];
  }

  public get formValid(): boolean {
    const { filtersModel } = this;
    let formValid = this.periodIsValid();
    for (let member in filtersModel) {
      if (!!filtersModel[member] || member === 'calculatedLocalityLevelAndType') continue;
      formValid = false;
    }
    return formValid;
  }

  private periodIsValid(): boolean {
    const { filtersModel } = this;
    var currentYear = new Date().getFullYear();
    const chosenPeriod = filtersModel.chosenPeriod || { value: { dtYearInit: currentYear, dtYearFinal: currentYear } };

    return chosenPeriod.value.dtYearInit === chosenPeriod.value.dtYearFinal;
  }

  public get limitsPeriodForm(): Period {
    if (!!this.limitValues) return this.limitValues;
    this.limitValues = this.getPeriod(ReportEnum.RegistrationByBrandAndSegment);
    return this.limitValues;
  }
}
